import React, { useState } from "react";
import "./register/register.css";
import { Link as Linker, useNavigate } from "react-router-dom";
import logo from '../assets/logo.png'
import { Alert } from "flowbite-react";
import { HiInformationCircle } from "react-icons/hi";
import { API_BASE_URL } from "../config";
import axios from "axios";

const SignIn = () => {
  const navigate = useNavigate();
  const front_end_url = window.location.origin;

  const [showLoginError, setShowLoginError] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [inputData, setInputData] = useState({
    email: "",
    password: "",
  });

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setInputData((prev) => ({ ...prev, [fieldName]: value }));
  };

  const handleLogin = async () => {
    setShowLoginError(false);
    setShowSuccessAlert(false);

    setIsLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/login`, {
        email: inputData.email,
        password: inputData.password,
      });

      setShowSuccessAlert(true);

      const { user, token } = response.data;
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("auth_token", token);

      let enrollments = [];
      try {
        const enrollmentsRes = await axios.get(`${API_BASE_URL}/enrollments`, {
          headers: { Authorization: `Bearer ${token}` }, // force it for this call
        });
        enrollments = Array.isArray(enrollmentsRes.data) ? enrollmentsRes.data : [];
      } catch (e) {
        console.error("Enrollments fetch failed:", e?.response?.status, e?.response?.data);
        enrollments = [];
      }

      setTimeout(() => {
        navigate(enrollments.length === 0 ? "/subjects" : "/user-dashboard");
      }, 800);
    } catch (err) {
      console.error("Login failed:", err?.response?.status, err?.response?.data);
      setShowLoginError(true);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="struct min-h-screen bg-gray-100">
    <a
      href={front_end_url}
      className="absolute top-4 left-4 sm:left-7 z-10 flex items-center gap-1 no-underline hover:no-underline before:content-none after:content-none"
    >
      <img src={logo} className="h-10 w-10 block" alt="EduBahamas logo" />

      <h2 className="font-bold text-[#1896b9] lg:text-white text-[22px] sm:text-[25px] leading-none">
        EduBahamas
      </h2>
    </a>

      <div className="min-h-screen w-full grid grid-cols-1 lg:grid-cols-2">
        <div className="hidden lg:flex flex-col justify-center items-center text-center w-full bg-[#1896b9] px-6 py-14 lg:py-0">
          <p className="text-gray-100">Nice To See You Again</p>
          <h1 className="mt-2 text-gray-100 text-4xl sm:text-5xl lg:text-6xl 2xl:text-8xl max-w-[22ch]">
            Welcome Back
          </h1>
        </div>

        <div className="flex flex-col items-center justify-center text-center w-full px-6 py-10">
          <div className="w-full max-w-md">
            {showLoginError && (
              <Alert
                className="mt-3"
                color="failure"
                icon={HiInformationCircle}
                onDismiss={() => setShowLoginError(false)}
              >
                Incorrect email or password
              </Alert>
            )}
            {showSuccessAlert && (
              <Alert
                className="mt-3"
                color="success"
                icon={HiInformationCircle}
                onDismiss={() => setShowSuccessAlert(false)}
              >
                Login Successful!
              </Alert>
            )}
          </div>

          {/* Form */}
          <form
            className="bg-gray-100 rounded-md w-full max-w-md"
            onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}
          >
            <h2 className="text-[#1896b9] py-5 mt-4 sm:mt-[10%] mb-10 sm:mb-[90px] text-center text-4xl font-bold">
              Sign In
            </h2>

            <div className="my-5">
              <input
                className="focus:ring-transparent border border-gray-200 shadow-md border-t-0 border-l-0 border-r-0 outline-none focus:shadow-[gray] py-5 px-3 rounded-md w-full"
                type="email"
                placeholder="Email"
                value={inputData.email}
                onChange={(e) => handleInputChange(e, "email")}
                autoComplete="email"
              />
            </div>

            <div className="my-5">
              <input
                className="focus:ring-transparent border border-gray-200 border-t-0 border-l-0 border-r-0 outline-none focus:shadow-[gray] shadow-md py-5 px-3 rounded-md w-full"
                type="password"
                placeholder="Password"
                value={inputData.password}
                onChange={(e) => handleInputChange(e, "password")}
                autoComplete="current-password"
              />
            </div>

              <div className="flex flex-col justify-center items-center w-full">
                <button
                  type="submit"
                  id="button-custom"
                  disabled={isLoading}
                  className={`w-full rounded-md bg-[#1896b9] hover:bg-[#126e87]
                    my-8 sm:my-10 mt-[30px]
                    text-[14px] text-white
                    h-12 px-4
                    flex items-center justify-center
                    leading-none
                    ${isLoading ? "opacity-70 cursor-not-allowed" : ""}`}
                >
                  {isLoading ? "Signing In..." : "Sign In"}
                </button>
                
              <Linker to="/forgot-password" className="hover:bg-transparent hover:before:w-0">
                <h1 className="text-[12px] text-gray-500 hover:underline">
                  Forgot Password?
                </h1>
              </Linker>
            </div>

            <Linker className="hover:bg-transparent hover:before:w-0" to="/register">
              <p className="text-gray-600 mt-3 flex justify-center items-center text-[14px] hover:underline">
                Don't have an account? &nbsp; <b>Register Now</b>
              </p>
            </Linker>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
